import React, { memo, useMemo } from 'react';
import { createUseStyles, Text, Checkbox } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import StepsHeader from '../StepHeader';

import styles from './styles';

const useStyles = createUseStyles(styles, 'MatchFieldsHeader');

const MatchFieldsHeader = memo(
    ({
        entityLabel,
        data,
        errors,
        toggleMatchMandatory,
        toggleMatchMandatoryExtra,
        toggleMatchMandatoryStandard,
    }) => {
        const classes = useStyles();
        const { t } = useWeb5Context();

        const mandatoryCheckbox = useMemo(() => {
            if (data.importType === 'update') {
                return (
                    <div className={classes.matchMandatory}>
                        <Text className={classes.matchMandatoryText}>
                            {t('cfm_action_import_check_mandatory')}
                        </Text>
                        <Checkbox
                            color="actionMajor"
                            onChange={toggleMatchMandatory}
                            checked={data.matchMandatory}
                        />
                    </div>
                );
            }
            return (
                <div className={classes.matchMandatoryFieldTypes}>
                    <div className={classes.matchMandatoryFieldTypesContent}>
                        <div className={classes.matchMandatoryStandard}>
                            <Text className={classes.matchMandatoryText}>
                                {t('cfm_action_import_check_mandatory_standard')}
                            </Text>
                            <Checkbox
                                color="actionMajor"
                                onChange={toggleMatchMandatoryStandard}
                                checked={data.matchMandatoryStandard}
                                isDisabled={true}
                            />
                        </div>
                        <div className={classes.matchMandatoryExtra}>
                            <Text className={classes.matchMandatoryText}>
                                {t('cfm_action_import_check_mandatory_custom')}
                            </Text>
                            <Checkbox
                                color="actionMajor"
                                onChange={toggleMatchMandatoryExtra}
                                checked={data.matchMandatoryExtra}
                            />
                        </div>
                    </div>
                </div>
            );
        }, [
            classes.matchMandatory,
            classes.matchMandatoryFieldTypes,
            classes.matchMandatoryFieldTypesContent,
            classes.matchMandatoryExtra,
            classes.matchMandatoryStandard,
            classes.matchMandatoryText,
            data.importType,
            data.matchMandatory,
            data.matchMandatoryExtra,
            data.matchMandatoryStandard,
            t,
            toggleMatchMandatory,
            toggleMatchMandatoryExtra,
            toggleMatchMandatoryStandard,
        ]);

        return (
            <StepsHeader
                title={t('cfm_label_match_fields', [entityLabel])}
                subtitle={t('cfm_label_match_fields_desc', [entityLabel])}
                errors={errors}
            >
                {mandatoryCheckbox}
            </StepsHeader>
        );
    },
);

export default MatchFieldsHeader;
